import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../../Component/Footer/Footer';
import TransitionAssessment from '../../Component/TuroAlternative/TransitionAssessment';
import '../../Component/TuroAlternative/TuroAlternative.css';

// Transition assessment funnel shared by /turo-alternative, /tnt-group and the
// home page. Every CTA on those pages leads here; the form captures the lead, then embeds
// the LeadConnector booking calendar prefilled with the prospect's details.
const TransitionPlan = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Back returns to whichever page sent the visitor. Router <Link>s leave an
  // in-app history entry (location.key !== 'default'); the plain <a> CTAs on
  // /tnt-group and home do a full load, so fall back to a same-origin referrer.
  // Visitors who landed here directly get /turo-alternative.
  const handleBack = (e) => {
    const cameFromSite =
      location.key !== 'default' ||
      (document.referrer && new URL(document.referrer).origin === window.location.origin);
    if (cameFromSite) {
      e.preventDefault();
      navigate(-1);
    }
  };

  // The site has no global scroll restoration; without this, arriving from a
  // CTA at the bottom of the landing page keeps that scroll position.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    <Helmet>
      <title>Build Your FREE Transition Plan | Rentid</title>
      <meta
        name="description"
        content="Answer a few questions about your fleet, insurance, and current rental operation and we'll build your roadmap from marketplace host to independent rental operator."
      />
      <meta name="robots" content="noindex, follow" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    <main className="mpa-page">
      <section className="mpa-tp">
        <div className="mpa-tp-inner">
          <Link to="/turo-alternative" className="mpa-tp-back" onClick={handleBack}>
            <ArrowLeft size={16} />
            Back
          </Link>

          <div className="mpa-tp-head">
            <p className="mpa-eyebrow">Free transition strategy meeting</p>
            <h1 className="mpa-tp-title">Build your transition plan.</h1>
            <p className="mpa-tp-sub">
              Four quick steps. We&apos;ll use your answers to prepare for your strategy meeting so
              the conversation focuses on your business, your gaps, and your path forward.
            </p>
          </div>

          <div className="mpa-tp-form">
            <TransitionAssessment />
          </div>
        </div>
      </section>
    </main>

      <Footer />
    </>
  );
};

export default TransitionPlan;
